import { jsx as c } from "react/jsx-runtime";
import { Resolvable as v } from "../utils/resolvable.js";
import { selectBundle as x } from "@duckdb/duckdb-wasm";
import e from "react";
const s = e.createContext(null), a = e.createContext(null), i = e.createContext(null), h = () => e.useContext(s), B = () => e.useContext(a), D = () => e.useContext(i), b = (u) => {
  const [l, o] = e.useState(
    new v()
  ), t = e.useRef(null), d = e.useCallback(async () => l.error ? null : l.value ? l.value : t.current ? await t.current : (t.current = (async () => {
    try {
      o((n) => n.updateRunning());
      const r = await x(
        u.bundles
      );
      return t.current = null, o((n) => n.completeWith(r)), r;
    } catch (r) {
      return t.current = null, console.error(r), o((n) => n.failWith(r)), null;
    }
  })(), t.current), [u.bundles]);
  return /* @__PURE__ */ c(s.Provider, { value: u.logger, children: /* @__PURE__ */ c(i.Provider, { value: d, children: /* @__PURE__ */ c(a.Provider, { value: l, children: u.children }) }) });
};
export {
  b as DuckDBPlatform,
  B as useDuckDBBundle,
  D as useDuckDBBundleResolver,
  h as useDuckDBLogger
};
